import axios from 'src/axios';
import { APICONSTANTS } from 'src/components/Constants';

/**
 * Pushes one or more variants from a test record into the patient's genotype.
 * Variants are deduped server-side by (gene, variantG, variantC, variantP).
 * The backend enriches each new variant with a ClinVar interpretation lookup.
 *
 * @param {Object} args
 * @param {string} args.user_id          MongoDB user_id (proband or family owner)
 * @param {string} args.familyMemberId   familyMemberId target (any value when isProband)
 * @param {boolean} args.isProband       true if pushing to the proband
 * @param {string} args.gene             gene symbol (HGNC) — used as genotype.id/name
 * @param {string} [args.name]           genotype display name (defaults to `gene`)
 * @param {Array<Object>} args.variants  list of { variantG, variantC, variantP,
 *                                       labInterpretation, sourceTestId,
 *                                       sourceTestName, sourceTestDate }
 */
export const pushVariantsToGenotype = ({
  user_id,
  familyMemberId,
  isProband,
  gene,
  name,
  variants
}) => {
  if (!user_id || !familyMemberId || !gene || !Array.isArray(variants)) {
    return Promise.reject(
      new Error('pushVariantsToGenotype: missing required arguments')
    );
  }

  const url = APICONSTANTS.pushVariantsToGenotype
    .replace(':user_id', user_id)
    .replace(':familyMemberId', familyMemberId);

  return axios.post(url, {
    gene,
    name: name || gene,
    isProband: Boolean(isProband),
    variants
  });
};
